if( window.console == null ){
    window.console = {
        log: function (p) {},
    };
}

var 
    _body,
    _window
;

var asn_FN = function(){
    asn = this
    asn.init()
};

(function($){

    asn_FN.prototype = {

        init: function () {

            _body = $( 'body' )
            _window = $( window )
            _vp_width = Utils.getPageWidth()

            asn.editButtons()
            asn.bindCanais()
            asn.bindPodcasts()
            asn.bindSplash()
            asn.bindFalecom()
            asn.bindSelect()

        },

        // Properties of Class
        properties: {
            timeEffects: 400, // Tempo para os efeitos
            device: 'desktop', // Device default
            scrollTop: 0,
            loading: false,
            userbars: false,
        },

        bindFalecom : function(){

            const $falecom = $('#content.fale-conosco .texts-form')
            if( !$falecom.length ) return true

            const 
                $trigger = $falecom.find( 'button' ).first(),
                $switcher = $falecom.find( '.switcher' ).first(),
                $form = $falecom.find( 'div.form' ).first()
            ;

            $trigger.on( 'click', function(e){

                e.preventDefault()

                $switcher.slideUp( 500 )
                $form.slideDown( 600 )
            
            })
            
        },

        bindSelect : function(){

            $( 'body' ).on( 'change', 'select', function(event){

                this.$ = this.$ || $( this )
                this.$s2 = this.$s2 || this.$.siblings('.select2')
                
                if( this.value === '' ){
                    this.$s2.removeClass('filled')
                }
                else {
                    this.$s2.addClass('filled')
                }

            }).trigger( 'select' )

        },

        bindSplash : function(){

            // Elements
            const 
                splash = document.querySelector( 'section.splash' ),
                close = document.querySelector( 'section.splash > div > div > button.close' ),
                access = document.querySelector( 'section.splash > div > div > a.button' ),
                cookie = Cookie.get( 'splash-closed' ),
                views = ( cookie === '' ) ? 0 : parseInt( cookie );
            ;

            // Not exists
            if( splash === null || views >= 5 ) return true;

            // Show
            splash.classList.add( 'showing' );
            asn.lockScroll();

            // Click out
            splash.addEventListener( 'click', function( event ){
                if( event.target.classList.contains( 'splash' ) ){
                    asn.closeSplash( splash, views );
                }
            });

            // Close button
            close.addEventListener( 'click', function(){
                asn.closeSplash( splash, views );
            });
            access.addEventListener( 'click', function(){
                asn.closeSplash( splash, views );
            });
            
        },

        closeSplash : function( splash, views ){
            splash.classList.remove( 'showing' );
            asn.unlockScroll();
            Cookie.set( 'splash-closed', ( views + 1 ) );
        },

        bindCanais : function(){

            const $canais = $( 'section.acesso-canais' );
            
            if( $canais.length ){

                const totalCanais = $( '.canais-item', $canais ).length;
                if( totalCanais > 1 ){

                    const __break = totalCanais === 3 ? 920 : 600; 
                    if( _vp_width <= __break ){
                        
                        const $slider = $( '.swiper', $canais );
                        var swiper = new Swiper(
                            $slider.get(0),
                            {
                                spaceBetween: 10,
                                pagination: {
                                    el: ".swiper-pagination",
                                    clickable: true
                                },
                            }
                        );

                    }

                }
                
            }
            
        },

        bindPodcasts : function(){

            const $podcasts = $( 'section.lastest-podcasts' );
            if( $podcasts.length ){

                if( _vp_width <= 720 ){
                    
                    const 
                        $slider = $( '.swiper', $podcasts ),
                        $pager = $( '.swiper-pagination', $slider )
                    ;
                    var swiper = new Swiper(
                        $slider.get(0),
                        {
                            spaceBetween: 10,
                            pagination: {
                                el: $pager.get( 0 ),
                                clickable: true
                            },
                        }
                    );

                }
                
            }
            
        },

        editButtons : function(){

            var $buttons = $( 'span[data-action="admin-edit"]' );
            if( !$buttons.length ) return true;

            $.ajax({
                url : Piki.ajaxurl + '?action=piki_user_logged',
                type : 'POST',
                dataType : 'JSON'
            })
            .done(function( response ){

                if( response.logged == false ) {
                    
                    $buttons.remove();
                
                }
                else {

                    $buttons.each(function(){
                        this.$ = this.$ || $( this );
                        const $link = $( '<a href="'+ this.$.data( 'url' ) +'" class="edit-link ' + this.$.data( 'type' ) + '" title="' + this.title + '" target="_blank" rel="noopener noreferrer" tabindex="-1"><span>Editar</span></a>' ).insertAfter( this.$ );
                        this.$.remove();
                    });

                }                
            
            })
            .fail(function( error ){

                $buttons.remove();
                
            });

        },

        // Função de resize da janela do browser ( Define qual o viewport )
        resizing: function () {
            
            var _wWidth = _window.outerWidth();

            // Define qual o viewport
            if( _wWidth < 768 ){
                asn.properties.device = 'smartphone';
            }
            else if ( _wWidth >= 768 && _wWidth <= 1279 ){
                asn.properties.device = 'tablet';
            }
            else { 
                asn.properties.device = 'desktop';
            }

            if ( asn.properties.device === 'desktop' ){
                _body
                    .removeClass( 'tablet' )
                    .removeClass( 'mobile' )
                    .addClass( 'desktop' )
                ;
            } 
            else if( asn.properties.device === 'tablet' ){
                _body
                    .removeClass( 'desktop' )
                    .removeClass( 'mobile' )
                    .addClass( 'tablet' )
                ;
            } 
            else if( asn.properties.device === 'smartphone' ){
                _body
                    .removeClass( 'desktop' )
                    .removeClass( 'tablet' )
                    .addClass( 'mobile' )
                ;
            }
        
        },

        bindIsNotis : function(){

            var $isnotiss = $( '.component-is-not-is' );

            $( '.component-is-not-is ul' ).hover(
                function(){
                    asn.lockScroll();
                },
                function(){
                    asn.unlockScroll();
                }
            );

        },

        bindFooterNav: function bindFooterNav(){

            var $fnav = $( 'footer.navigation' );
            if( !$fnav.length ) return;

            var $links = $( 'a', $fnav );

            $links.hover(
                function(){
                    this.$ = this.$ || $( this );
                    $links.removeClass( 'active' );
                    this.$.addClass( 'active' );
                },
                function(){
                    this.$ = this.$ || $( this );
                   this.$.removeClass( 'active' );
                }
            );

        },

        bindSanfonas : function bindSanfonas(){

            // Informações úteis
            $( '.piki-sanfona' ).pikiSanfona({              
                items: '>div',
                headers: '>header',
                contents: '>div'
            });
        
        },

        // Controla o scroll da página
        scrolling: function( e ){

            var 
                $header = $( 'header' ),
                $nav = $( 'body > nav' )
            ;

            if (
                _window.scrollTop() < asn.properties.scrollTop &&
                _window.scrollTop() > $header.innerHeight() + $header.offset().top
            ){
                $nav.addClass( 'active' );
            } 
            else {
                $nav.removeClass( 'active' );
            }

            // Close userbars
            asn.userBar.close();

            // Keep last scrolltop
            asn.properties.scrollTop = _window.scrollTop();
        
        },

        // Lock scroll
        lockScroll : function(){
            $('html,body').addClass( 'lockscroll' );
        },

        // Unlock scroll
        unlockScroll : function(){
            $('html,body').removeClass( 'lockscroll' );
        }

    };

    window.addEventListener( 'DOMContentLoaded', function(){
        asn = new asn_FN();
    });
  
})(jQuery);
